import React, { FC, useEffect } from 'react';

import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';

import { SolicitacaoComentario } from 'view/component/SolicitacaoAtividade/SolicitacaoComentario/SolicitacaoComentario'
import { H3, TextoPequeno } from 'view/component/Tipografia/Texto';
import { SolicitacaoAtividadeCarregando } from 'view/component/SolicitacaoAtividade/SolicitacaoAtividade';

import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { Comentario } from 'model/solicitacao/comentario/Comentario';
import { NovoComentarioTag } from './NovoComentarioTag/NovoComentarioTag';

import { SolicitacaoCorrenteAction } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.action';
import { ComentariosSolicitacaoSelector } from 'store/ComentariosSolicitacao/ComentariosSolicitacao.selector';
import { ComentariosSolicitacaoAction } from 'store/ComentariosSolicitacao/ComentariosSolicitacao.action';
import { MensagensErroServidor } from 'view/component/MensagensErroServidor/MensagensErroServidor';
import { ResponseError } from 'view/component/MensagensErroServidor/ErroServidor.utils';
import { useHashFocus } from 'util/useHashFocus';


interface SolicitacaoComentariosSecaoProps {
  solicitacao: SolicitacaoDetalhada
}

export const SolicitacaoComentariosSecao: FC<SolicitacaoComentariosSecaoProps> = ({solicitacao}) => {
  const idSolicitacao = solicitacao.id;

  const comentarios = useSelector(ComentariosSolicitacaoSelector.lista.elementos);
  const isFinalDaLista = useSelector(ComentariosSolicitacaoSelector.lista.isFinalDaLista);
  const erros = useSelector(ComentariosSolicitacaoSelector.lista.erros);
  const estado = useSelector(ComentariosSolicitacaoSelector.lista.estado);
  
  const dispatch = useDispatch();
  const carregarProximaPagina = () => dispatch(ComentariosSolicitacaoAction.lista.carregarProximaPagina(idSolicitacao));
  const tentarNovamente = () => dispatch(ComentariosSolicitacaoAction.lista.carregarNovamentePaginaAtual(idSolicitacao));

  const onSalvo = async (comentario: Comentario) => {
    if (comentario.anexos.length > 0) {
      dispatch(SolicitacaoCorrenteAction.anexos.adicionarNaLista(comentario.anexos));
    }
  }

  useEffect(() => {
    if (idSolicitacao !== 0) {
      dispatch(ComentariosSolicitacaoAction.lista.iniciar(idSolicitacao));
    }
  }, [idSolicitacao, dispatch]);

  useHashFocus(/^#(comentario-\d+)$/, estado);

  const comentariosTags = comentarios?.map(comentario => <SolicitacaoComentario key={comentario.id} comentario={comentario} solicitacao={solicitacao} />);
  return <Section>
      <H3 srOnly>Comentários</H3>

      <NovoComentarioTag solicitacao={solicitacao} onSalvo={onSalvo} />

      <div>
        <InfiniteScroll
          dataLength={comentarios?.length ?? 0}
          next={carregarProximaPagina}
          hasMore={!isFinalDaLista}
          loader={<ComentariosLoading erros={erros} tentarNovamente={tentarNovamente} />}
          endMessage={<Rodape>Fim dos comentários</Rodape>}
          scrollableTarget="bloco-principal"
        >
          {comentariosTags}
        </InfiniteScroll>
      </div>
    </Section>
}

interface ComentariosLoadingParams {
  erros?: ResponseError;
  tentarNovamente: () => void;
}

const ComentariosLoading: FC<ComentariosLoadingParams> = ({erros, tentarNovamente}) => {
  if (erros !== undefined) {
    return <MensagensErroServidor erro={erros} retry={tentarNovamente} />
  } else {
    return <>
      <SolicitacaoAtividadeCarregando />
      <SolicitacaoAtividadeCarregando />
      <SolicitacaoAtividadeCarregando />
    </>
  }
}

const Rodape = styled(TextoPequeno)`
  width: 100%;
  text-align: center;
  display: inline-block;
`;

const Section = styled.section`
  width: 100%;
`;
